<template>
  <div>
    <h1 class="text-center">Links</h1>

    <div class="text-center mt-4">
      <p>Lidt forskellige links vi bruger:</p>

      <!-- Todo: fede styling - google og bliv inspireret -->
      <ul class="links">
        <li v-for="(link, index) in links" :key="index">
          <a
            :href="link.href ? link.href : '#'"
            :target="(link.href ? '_blank' : null)"
          >{{ link.title }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Links',
  data: () => ({
    links: [
      {
        title: 'Dansk Kennel Klub',
        href: 'https://www.dkk.dk/'
      },
      {
        title: 'Dansk Retriever Klub',
        href: 'https://www.dansk-retriever-klub.dk/'
      },
      {
        title: 'Labrador Retriever',
        href: 'http://www.labrador-retriever.dk/'
      },
      {
        title: 'Hundefotografen v/ Marlene Birkebæk',
        href: 'http://hundefotografen.dk/'
      },
      {
        title: 'CNM-test',
        href: '' // gammelt link fører til en underlig kinesisk side
      },
      {
        title: 'Optigen',
        href: '' // gammelt link redirecter
      },
      {
        title: 'EIC',
        href: '' // gammelt link er 404
      }
    ]
  }),
  computed: {
    ...mapState(['test', 'dogs'])
  }
};
</script>

<style lang="less">
.links {
  li {
    list-style: none;
  }
}
</style>